<script lang="ts">
  import type { VoiceType } from 'shared/definitions/musicTheory/voiceTypes';
  import { voiceTypes } from 'shared/definitions/musicTheory/voiceTypes';

  export let voiceType: VoiceType = 'mezzo-soprano';
  let clazz = '';
  export { clazz as class };
</script>

<div class="flex flex-row flex-wrap justify-center">
  <select style="padding: 0.2em;" class="text-center" bind:value={voiceType}>
    {#each voiceTypes as candidateVoiceType}
      <option value={candidateVoiceType}>{candidateVoiceType}</option>
    {/each}
  </select>
  <!-- {#each voiceTypes as candidateVoiceType}
    <label class={clazz}>
      <input
        class="mr-2"
        type="radio"
        bind:group={voiceType}
        name="voice-type-selector"
        value={candidateVoiceType}
      />{candidateVoiceType}
    </label>
  {/each} -->
</div>
